import * as React from "react";

export const SvgRemovePassenger = ({ color, ...props }) => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12.9992 0.200195C5.94087 0.200195 0.199219 5.94184 0.199219 13.0002C0.199219 20.0585 5.94087 25.8002 12.9992 25.8002C20.0576 25.8002 25.7992 20.0575 25.7992 13.0002C25.7992 5.94284 20.0576 0.200195 12.9992 0.200195ZM12.9992 23.8172C7.03547 23.8172 2.18217 18.9649 2.18217 13.0002C2.18217 7.03545 7.03547 2.18315 12.9992 2.18315C18.963 2.18315 23.8163 7.03545 23.8163 13.0002C23.8163 18.9649 18.964 23.8172 12.9992 23.8172Z"
			fill={color}
			stroke={color}
			strokeWidth="0.2"
		/>
		<rect
			x="7.29844"
			y="12.1002"
			width="11.4"
			height="1.8"
			rx="0.9"
			fill={color}
			stroke={color}
			strokeWidth="0.2"
		/>
	</svg>
);
